import { createDialogProvider } from "src/components/Dialog";
import { AccountAlreadyClosedDialogContext } from "./context";
import { AccountAlreadyClosedDialog } from "./AccountAlreadyClosedDialog";

export const { DialogProvider: AccountAlreadyClosedDialogProvider } =
  createDialogProvider(
    AccountAlreadyClosedDialogContext,
    AccountAlreadyClosedDialog,
    "AccountAlreadyClosedDialog"
  );
